import autoTable from "jspdf-autotable";

import {
    createReportLayout,
} from "./reportLayout";

import {
    drawInfoCard,
} from "./reportHelpers";
import InfoIcon from "../assets/info.png";
import VerifiedIcon from "../assets/verified.png";

export const exportCommissionReport = (
    driverPartner,
    payouts
) => {
    const statementId =
        `STM-${Date.now()}`;

    const generatedAt =
        new Date().toLocaleString();

    const doc =
        createReportLayout(
            {
                title:
                    "Commission Statement",

                statementId,

                generatedAt,
            }
        );

    const totalPaid =
        payouts
            .filter(
                (
                    payout
                ) =>
                    payout.status ===
                    "Paid"
            )
            .reduce(
                (
                    total,
                    payout
                ) =>
                    total +
                    Number(
                        payout.amount
                    ),
                0
            );

    const totalPending =
        payouts
            .filter(
                (
                    payout
                ) =>
                    payout.status ===
                    "Pending"
            )
            .reduce(
                (
                    total,
                    payout
                ) =>
                    total +
                    Number(
                        payout.amount
                    ),
                0
            );

    /*
    -----------------------------------------
    PARTNER INFO
    -----------------------------------------
    */

    doc.setFontSize(8);

    doc.setTextColor(
        120
    );

    doc.text(
        "PARTNER NAME",
        15,
        75
    );

    doc.text(
        "REFERRAL CODE",
        85,
        75
    );

    doc.text(
        "STATEMENT PERIOD",
        145,
        75
    );

    doc.setFontSize(11);

    doc.setTextColor(
        20
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.text(
        driverPartner.user?.first_name ||
        driverPartner.user?.last_name
            ? `${driverPartner.user?.first_name || ""} ${driverPartner.user?.last_name || ""}`.trim()
            : driverPartner.user?.username || "-",
        15,
        82
    );

    doc.text(
        driverPartner.partner_referral_code,
        85,
        82
    );

    doc.text(
        "July 2026",
        145,
        82
    );

    /*
    -----------------------------------------
    SUMMARY CARDS
    -----------------------------------------
    */

 const drawInfoCard = (
    doc,
    {
        x,
        y,
        width,
        height,
        title,
        value,
        subtitle,
        background = [248, 250, 252],
        titleColor = [120, 120, 120],
        valueColor = [20, 20, 20],
        subtitleColor = [120, 120, 120],
    }
) => {
    doc.setFillColor(
        ...background
    );

    doc.roundedRect(
        x,
        y,
        width,
        height,
        3,
        3,
        "F"
    );

    // Title
    doc.setFontSize(7);
    doc.setTextColor(
        ...titleColor
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.text(
        title,
        x + 5,
        y + 7
    );

    // Value
    doc.setFontSize(11);

    doc.setTextColor(
        ...valueColor
    );

    doc.text(
        value,
        x + 5,
        y + 16
    );

    // Subtitle
    if (subtitle) {
        doc.setFontSize(
            6
        );

        doc.setFont(
            "helvetica",
            "normal"
        );

        doc.setTextColor(
            ...subtitleColor
        );

        doc.text(
            subtitle,
            x + 5,
            y + 23
        );
    }
};

drawInfoCard(
    doc,
    {
        x: 15,
        y: 95,
        width: 70,
        height: 25,

        title:
            "TOTAL EARNINGS",

        value: `P${totalPaid.toFixed(
            2
        )}`,

        subtitle:
            "BWP",

        background: [
            36,
            83,
            255,
        ],

        titleColor: [
            255,
            255,
            255,
        ],

        valueColor: [
            255,
            255,
            255,
        ],

        subtitleColor: [
            255,
            255,
            255,
        ],
    }
);

    drawInfoCard(
        doc,
        {
            x: 90,
            y: 95,
            width: 45,
            height: 25,
            title:
                "PENDING",
            value: `P${totalPending.toFixed(
                2
            )}`,
            subtitle:
                "Next payout cycle",
        }
    );

    drawInfoCard(
        doc,
        {
            x: 140,
            y: 95,
            width: 55,
            height: 25,
            title:
                "PRIMARY METHOD",
            value:
                driverPartner.payment_method ||
                "-",
            subtitle:
                "Verified",
        }
    );

    /*
    -----------------------------------------
    COMMISSION TABLE
    -----------------------------------------
    */

   const totalPayoutAmount =
    payouts.reduce(
        (
            total,
            payout
        ) =>
            total +
            Number(
                payout.amount ||
                    0
            ),
        0
    );

    const transactionCount =
    payouts.length;

doc.setFontSize(
    16
);

doc.setFont(
    "helvetica",
    "bold"
);

doc.setTextColor(
    30
);

doc.text(
    "Commission Ledger",
    15,
    138
);

/*
Transaction Count Badge
*/

doc.setFillColor(
    232,
    238,
    255
);

doc.roundedRect(
    78,
    133.5,
    24,
    6,
    3,
    3,
    "F"
);

doc.setFontSize(
    7
);

doc.setTextColor(
    120
);

doc.text(
    `${transactionCount} Transaction${transactionCount !== 1 ? "s" : ""}`,
    82,
    138
);

autoTable(
    doc,
    {
        startY: 143,

        head: [
            [
                "REFERENCE ID",
                "PERIOD",
                "TRANSACTION TYPE",
                "STATUS",
                "AMOUNT (P)",
            ],
        ],

        body: [
            ...payouts.map(
                (
                    payout
                ) => [
                    payout.payment_reference ||
                        "-",

                    payout.payout_period ||
                        "-",

                    "Referral Commission",

                    payout.status,

                    Number(
                        payout.amount
                    ).toFixed(
                        2
                    ),
                ]
            ),

            [
                {
                    content:
                        "TOTAL PAYOUT AMOUNT",
                    colSpan: 4,
                    styles: {
                        halign:
                            "right",
                        fontStyle:
                            "bold",
                        fillColor:
                            [
                                248,
                                250,
                                252,
                            ],
                    },
                },

                {
                    content: `P${totalPayoutAmount.toFixed(
                        2
                    )}`,

                    styles: {
                        halign:
                            "right",

                        fontStyle:
                            "bold",

                        textColor:
                            [
                                36,
                                83,
                                255,
                            ],

                        fillColor:
                            [
                                248,
                                250,
                                252,
                            ],

                        fontSize:
                            12,
                    },
                },
            ],
        ],

        headStyles: {
            fillColor: [
                232,
                238,
                255,
            ],

            textColor:
                20,

            fontStyle:
                "bold",
        },

        bodyStyles: {
            textColor:
                40,
            fontSize:
                9,
        },

        alternateRowStyles:
            {
                fillColor:
                    [
                        252,
                        252,
                        252,
                    ],
            },

        styles: {
            lineColor:
                [
                    235,
                    235,
                    235,
                ],
            lineWidth:
                0.2,
        },
    }
);

    /*
    -----------------------------------------
    NOTES
    -----------------------------------------
    */

    const finalY =
        doc.lastAutoTable
            .finalY +
        15;


/*
-----------------------------------------
STATEMENT NOTES
-----------------------------------------
*/

doc.setDrawColor(
    220
);

doc.roundedRect(
    15,
    finalY,
    180,
    35,
    3,
    3
);

doc.setFontSize(
    10
);

doc.setFont(
    "helvetica",
    "bold"
);

doc.setTextColor(
    40
);
doc.addImage(
    InfoIcon,
    "PNG",
    20,
    finalY + 5.6,
    5,
    5
);
doc.text(
    "STATEMENT NOTES",
    28,
    finalY +
        10
);

doc.setFontSize(
    9
);

doc.setFont(
    "helvetica",
    "normal"
);

doc.setTextColor(
    110
);

doc.text(
    [
        "This is a generated commission statement for the Mogoma Driver Partner Program.",
        "All earnings are subject to tax regulations according to your local jurisdiction.",
        "For discrepancies please contact partner-support@mogoma.co.bw within",
        "5 business days of the statement date.",
    ],
    20,
    finalY +
        18
);

/*
-----------------------------------------
AUTHENTIC DOCUMENT
-----------------------------------------
*/

const authY =
    finalY + 55;

doc.setTextColor(
    36,
    83,
    255
);

doc.setFontSize(
    11
);

doc.setFont(
    "helvetica",
    "bold"
);
doc.addImage(
    VerifiedIcon,
    "PNG",
    20,
    authY - 4,
    5,
    5
);
doc.text(
    "AUTHENTIC DOCUMENT",
    28,
    authY
);

doc.setFontSize(
    8
);

doc.setFont(
    "helvetica",
    "normal"
);

doc.setTextColor(
    120
);

doc.text(
    [
        "Recotech (Pty) Ltd. | Tlokweng, Plot Z17A Sefoke Ward | Botswana. | https://aigenix.co.bw/mogoma | +267 76 019 336" ,
        "This statement is electronically generated and remains valid without",
        "a physical signature.",
    ],
    20,
    authY + 8
);

/*
-----------------------------------------
BLUE FOOTER LINE
-----------------------------------------
*/

doc.setDrawColor(
    36,
    83,
    255
);

doc.setLineWidth(
    1
);

doc.line(
    15,
    authY + 25,
    195,
    authY + 25
);

    doc.save(
        `Commission_Statement_${driverPartner.partner_referral_code}.pdf`
    );
};